import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router'
import Settings from './Settings';
import Auth from './Auth';
// import StancebeamReducer from './StancebeamReducer';
import PlayerReducer from './PlayerReducer';
import CoachReducer from './CoachReducer';
import DashboardReducer from './DashboardReducer';
import SessionReducer from './SessionReducer';
import SwingReducer from './SwingReducer';
import MediaReducer from './MediaReducer';
import PlayerReportReducer from './PlayerReportReducer';


export default (history) => combineReducers({
  router: connectRouter(history),
  settings: Settings,
  auth: Auth,
  player: PlayerReducer,
  coach: CoachReducer,
  dashboard: DashboardReducer,
  session: SessionReducer,
  swing: SwingReducer,
  media: MediaReducer,
  playerReport: PlayerReportReducer
  // stancebeam: StancebeamReducer,
});
